// Hora "HH:MM" a partir do ISO (sent_at). Vazio se inválido. TZ local (igual aos balões).
export const formatHM = (iso) => {
    const d = new Date(iso);
    return isNaN(d.getTime()) ? "" : d.toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"});
};

// Duração compacta a partir de segundos. 0/inválido -> "—".
export const formatDuration = (s) => {
    if (!s || s < 1) return "—";
    if (s < 60) return `${s}s`;
    if (s < 3600) return `${Math.round(s / 60)}m`;
    return `${Math.round(s / 3600)}h`;
};
